var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("app-launcher-update", {
    attrs: {
      version: _vm.update.target,
      pending: _vm.update.pending,
      complete: _vm.update.complete,
      reports: _vm.update.reports,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }